import React from 'react';

import IMG_READER from 'assets/images/pos/reader-waiting.png';
import AnimatedCircle from 'components/generic/AnimatedCircle.component';
import Space from 'components/generic/Space.component';
import CurrencySign from 'components/price/CurrencySign.component';
import { useTranslation } from 'providers/GILT.provider';

import CN from './MessageOffline.module.scss';

const MessageWaiting = ({ price }) => {
  const { t } = useTranslation();
  return (
    <div data-bem="MessageWaiting">
      <AnimatedCircle>
        <img src={IMG_READER} alt="POS reader with a card over it" className={CN.image} />
      </AnimatedCircle>

      <div className={CN.title}>
        {t('composite.posMessages.waitingPart1')}
        <Space>
          <span className={CN.highlight}>
            <CurrencySign value={price} />
          </span>
        </Space>
        {t('composite.posMessages.waitingPart2')}
      </div>
    </div>
  );
};

export default MessageWaiting;
